import { CHAT_API_URL } from "../utils/constants";

class ChatApiService {
    async getConversations(filters = {}){
        const params = new URLSearchParams(filters);
        const response = await fetch(`${CHAT_API_URL}/conversaciones?${params}`);
        if (!response.ok) throw new Error('Error al obtener las conversaciones');
        const data = await response.json();
        // La API devuelve { $values: [...] }, extraemos el array
        return data.$values || data;
    }

    async getConversationById(id){
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${id}`);
        if (!response.ok) throw new Error('Error al obtener la conversación');
        return response.json();
    }

    async createConversation(conversationData){
        const response = await fetch(`${CHAT_API_URL}/conversaciones`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(conversationData)
        });
        if (!response.ok) throw new Error('Error al crear la conversación');
        return response.json();
    }

    async getMessages(conversationId, page = 1, limit=50){
        const url = `${CHAT_API_URL}/conversaciones/${conversationId}/mensajes?pagina=${page}&cantidad=${limit}`;
        const response = await fetch(url);
        if(!response.ok) throw new Error('Error al obtener los mensajes');
        const data = await response.json();
        
        // La API devuelve: { mensajes: { $values: [...] } }
        let mensajesArray = [];
        
        if (data.mensajes && data.mensajes.$values) {
            mensajesArray = data.mensajes.$values;
        } else if (data.mensajes && Array.isArray(data.mensajes)) {
            mensajesArray = data.mensajes;
        } else if (data.$values) {
            mensajesArray = data.$values;
        }
        
        return {
            mensajes: mensajesArray,
            totalMensajes: data.totalMensajes || mensajesArray.length,
            pagina: data.pagina || page,
            cantidadPorPagina: data.cantidadPorPagina || limit,
            tieneMas: data.tieneMas || false
        };
    }

        async searchConversations(termino) {
        const response = await fetch(
            `${CHAT_API_URL}/conversaciones/busqueda-global?termino=${encodeURIComponent(termino)}`
        );

        if (!response.ok) {
            throw new Error('Error al buscar conversaciones');
        }

        return response.json();
    }


    async sendMessage(conversationId, content, username, type = 'text'){
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${conversationId}/${username}/mensajes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ contenido: content, tipoMensaje: type })
        });
        if(!response.ok) throw new Error('Error al enviar el mensaje');
        return response.json();
    }

    async markAsRead(conversationId){
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${conversationId}/leer`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if(!response.ok) throw new Error('Error al marcar como leído');
        return response.json();
    }

    async attendConversation(conversationId, username){
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${conversationId}/atender?usuario=${encodeURIComponent(username)}`, {
            method: 'PUT',
        });
        if(!response.ok) throw new Error('Error al atender la conversación');
        return response.json();
    }

    async closeConversation(conversationId){
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${conversationId}/cerrar`, {
            method: 'PUT',
        });
        if(!response.ok) throw new Error('Error al cerrar la conversación');
        return response.json();
    }

    async getUnreadCount(){
        const response = await fetch(`${CHAT_API_URL}/conversaciones/no-leidos`);
        if(!response.ok) throw new Error('Error al obtener el conteo de mensajes no leídos');
        return response.json();
    }

    async sendMultimedia(conversationId, file, caption = ''){
        const formData = new FormData();
        formData.append('archivo', file);
        if (caption) {
            formData.append('caption', caption);
        }
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${conversationId}/multimedia`, {
            method: 'POST',
            body: formData,
            // NO incluir Content-Type - el browser lo agrega con boundary
        });
        if(!response.ok){
            const err = await response.json().catch(() => ({}));
            throw new Error(err.error || 'Error al enviar archivo multimedia');
        }
        return response.json();
    }


    async renovarUrlsConversacion(conversationId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${conversationId}/renovar-urls`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error al renovar URLs de la conversación');
        return response.json();
    }

    async getPossibleClients(id){
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${id}/clientes-posibles`);

        if (!response.ok) {
            throw new Error('Error al obtener clientes posibles');
        }

        return response.json();
    }

    async updateConversationClient(id, { idCliente}) {
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${id}/cliente`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ idCliente })
        });

        if (!response.ok) {
            // const errorData = await response.json();
            // throw new Error(errorData?.error || "Error updating conversation client");
            let errorMessage = "Error updating conversation client";
            try {
                const data = await response.json();
                if (data?.error) errorMessage = data.error;
            } catch (e) {
                console.error("Error parsing backend error response", e);
            }
            throw new Error(errorMessage);
        }

        return response.json();
        }

        async getClientsByPhone(phoneNumber) {
            const response = await fetch(`${CHAT_API_URL}/clientes/por-telefono/${phoneNumber}`);

            if (!response.ok) {
                throw new Error('Error al obtener clientes por teléfono');
            }

            return response.json();
        }

    async getPlantillas() {
        const response = await fetch(`${CHAT_API_URL}/plantillas`);
        if (!response.ok) throw new Error('Error al obtener las plantillas');
        const data = await response.json();
        return data.$values || data;
    }

    async enviarPlantilla(conversacionId, nombrePlantilla, variables) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${CHAT_API_URL}/conversaciones/${conversacionId}/plantilla`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ nombrePlantilla, variables })
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            if (response.status === 422) throw new Error(err.error || 'Plantilla inválida o variables incorrectas');
            throw new Error(err.error || 'Error interno del servidor');
        }
        return response.json();
    }
        
}

export default new ChatApiService();